import { defineStore } from 'pinia'
import { Incidencia } from '@/models/Incidencia'
import { IncidenciaItem } from '@/models/IncidenciaItem'
import { Category } from '@/models/Category'
import { Position } from '@/models/Position'
import { IncidenciaUserDescription } from '@/models/IncidenciaUserDescription'
import { UserFile } from '@/models/UserFile'
import { UserCredentials } from '@/models/UserCredentials'
import { ivpService } from '@/services/ivp-service'

export const useIncidenciaStore = defineStore('incidencia', {
    state: () => {
        return {
            current: {} as Incidencia,
            incidencias: [] as IncidenciaItem[],
            categories: [] as Category[],
            progress: 0,
            reference: null as string | null,
            user: null as UserCredentials | null
        }
    },
    getters: {
        getCategories: (state): (parent: string) => Category[] => {
            return (parent: string) => parent ? state.categories.find(category => category.etiqueta_xml.toLowerCase() === parent)?.fila as Category[] : state.categories
        },
        getPosition: (state): Position => state.current.position,
        getAddress (): string {
            return this.getPosition?.address
        },
        getFiles: (state): UserFile[] => state.current.files ?? [],
        getUserAndDescription: (state): IncidenciaUserDescription => {
            return {
                user: state.current.user ?? {},
                description: state.current.description
            }
        },
        getIncidenciaById: (state): (id: number) => IncidenciaItem | undefined => {
            return (id: number) => state.incidencias.find(i => i.Id === id)
        },
        isLoggedIn: (state): boolean => state.user !== null,
        isCurrentEmpty: (state): boolean => {
            return !state.current || Object.keys(state.current).length === 0
        }
    },
    actions: {
        setCategory (category: Category) {
            this.current.category = category
        },
        async loadCategories () {
            if (this.categories.length) return;
            this.categories = await ivpService.getCategories()
        },
        setPosition (position: Position) {
            this.current.position = position
        },
        setUserAndDescription (data: IncidenciaUserDescription) {
            this.current.user = data.user
            this.current.description = data.description
        },
        addFile (file: UserFile) {
            (this.current.files ??= []).push(file)
        },
        removeFile (file: UserFile) {
            this.current.files = this.current.files.filter(f => f.path !== file.path)
        },
        setPhoneId (uid: string) {
            this.current.phoneId = uid
        },
        setProgress (progress: number) {
            this.progress = progress
        },
        reset () {
            this.current = {} as Incidencia
            this.progress = 0
        },
        resetList () {
            this.incidencias = []
        },
        setUser (user: UserCredentials) {
            this.user = user
        },
        logout () {
            this.user = null
        }
    },
    persist: {
        storage: window.sessionStorage
    }
})
